
import { PolicyFormFields } from "../PolicyFormFields";
import { PolicyFormActions } from "./PolicyFormActions";
import { PolicyFormHeader } from "./PolicyFormHeader";
import { LeadSourceType } from "@/types/leadSource";

interface PolicyFormContainerProps {
  producer: string;
  policyType: string;
  insuranceCarrier: string;
  policyLine: string;
  policyNumber: string;
  startDate: Date;
  endDate: Date;
  premiumAmount: number;
  status: string;
  leadSource: LeadSourceType;
  policyAcquisitionType: string;
  onProducerChange: (value: string) => void;
  onPolicyTypeChange: (value: string) => void;
  onInsuranceCarrierChange: (value: string) => void;
  onPolicyLineChange: (value: string) => void;
  onPolicyNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStartDateChange: (date?: Date) => void;
  onEndDateChange: (date?: Date) => void;
  onPremiumAmountChange: (value: number) => void;
  onStatusChange: (value: string) => void;
  onLeadSourceChange: (value: LeadSourceType) => void;
  onPolicyAcquisitionTypeChange: (value: string) => void;
  onSalesDateChange?: (date: Date) => void;
  onSubmit: () => void;
  isSubmitDisabled?: boolean;
  isFormValid?: boolean;
  onCancel?: () => void;
  submitLabel?: string;
  showHeader?: boolean;
  clientName?: string;
  isSubmitting?: boolean;
}

export const PolicyFormContainer = ({
  producer,
  policyType,
  insuranceCarrier,
  policyLine,
  policyNumber,
  startDate,
  endDate,
  premiumAmount,
  status,
  leadSource,
  policyAcquisitionType,
  onProducerChange,
  onPolicyTypeChange,
  onInsuranceCarrierChange,
  onPolicyLineChange,
  onPolicyNumberChange,
  onStartDateChange,
  onEndDateChange,
  onPremiumAmountChange,
  onStatusChange,
  onLeadSourceChange,
  onPolicyAcquisitionTypeChange,
  onSalesDateChange,
  onSubmit,
  isSubmitDisabled,
  isFormValid,
  onCancel,
  submitLabel,
  showHeader = false,
  clientName,
  isSubmitting = false
}: PolicyFormContainerProps) => {
  // Use isFormValid if provided, otherwise fallback to !isSubmitDisabled
  const disableSubmit = isSubmitDisabled !== undefined ? isSubmitDisabled : (isFormValid !== undefined ? !isFormValid : false);
  
  return (
    <div className="space-y-4">
      {showHeader && <PolicyFormHeader onCancel={onCancel} clientName={clientName} />}
      <PolicyFormFields
        producer={producer}
        policyType={policyType}
        insuranceCarrier={insuranceCarrier}
        policyLine={policyLine}
        policyNumber={policyNumber}
        startDate={startDate}
        endDate={endDate}
        premiumAmount={premiumAmount}
        status={status}
        leadSource={leadSource}
        policyAcquisitionType={policyAcquisitionType}
        onProducerChange={onProducerChange}
        onPolicyTypeChange={onPolicyTypeChange}
        onInsuranceCarrierChange={onInsuranceCarrierChange}
        onPolicyLineChange={onPolicyLineChange}
        onPolicyNumberChange={onPolicyNumberChange}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onPremiumAmountChange={onPremiumAmountChange}
        onStatusChange={onStatusChange}
        onLeadSourceChange={onLeadSourceChange}
        onPolicyAcquisitionTypeChange={onPolicyAcquisitionTypeChange}
        onSalesDateChange={onSalesDateChange}
      />
      <PolicyFormActions
        onCancel={onCancel}
        onSubmit={onSubmit}
        isSubmitDisabled={disableSubmit}
        submitLabel={submitLabel}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};
